<template>
    <!-- DESCR：会议列表的视图页面 -->
    <div class="role-container">
        <!-- 页面信息描述 -->
        <el-row justify="center">
            <el-col :span="24" class="login-title">
                <div class="desc-box">
                    <div class="title">{{ tabRoleList[tabActive].title }}</div>
                    <br />
                    <div class="info">
                        {{ tabRoleList[tabActive].infolist[0] }}
                    </div>
                    <div class="info">
                        {{ tabRoleList[tabActive].infolist[1] }}
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="16">
                <div class="click-tips">
                    <span class="text-line">Your recent ConfChair roles are shown in the table below. Click on a role to
                        access it
                    </span>
                    <div>
                        <el-tag style="cursor: pointer;" @click="tabrole">{{ tabRoleList[tabActive].btntext }}</el-tag>
                    </div>
                </div>

                <el-table :data="conferenceMyList" style="width: 100%" border :row-class-name="tableRowClassName">
                    <el-table-column label="Id" width="100" align="center">
                        <template #default="scope">
                            <span>{{ scope.row.id }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Acronym" width="130" align="center">
                        <template #default="scope">
                            <el-text class="mx-1" type="primary" size="small">{{ scope.row.acronym }}</el-text>
                            <!-- <el-tag type="success">{{ scope.row.acronym }}</el-tag> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="Role">
                        <template #default="scope">
                            <el-button size="small" type="primary" @click="chairInner(scope.$index, scope.row)"
                                v-if="scope.row.hasChair">chair</el-button>
                            <el-button size="small" type="danger" @click="subreviewerInner(scope.$index, scope.row)"
                                color="#626aef" v-if="scope.row.hasSubreviewer">subreviewer</el-button>
                            <el-button size="small" type="success" @click="authorInner(scope.$index, scope.row)"
                                v-if="scope.row.hasPaper">author</el-button>
                            <el-button size="small" color="#626aef" :dark="isDark" @click="proceedingsInner(scope.$index, scope.row)" v-if="scope.row.hasAuProceedings">proceedings author ({{ scope.row.acronym }})</el-button>
                            <el-button size="small" color="#626aef" :dark="isDark" @click="proceedingsInner(scope.$index, scope.row)" v-if="scope.row.hasMaProceedings">proceedings manager ({{ scope.row.acronym }})</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
    </div>
</template>

<script setup>
import { ref, onMounted, inject } from "vue";
import { useRouter } from "vue-router";
import request from "../../network/request"


const router = useRouter()


// 切换的角色显示状态（最近、全部）
const tabActive = ref(0)
const tabRoleList = [
    {
        title: "My Recent Roles",
        infolist: ["To view all of your roles, click All Roles", "To access any other ConfChair features, please use the main menu"],
        btntext: "All Roles",
    },
    {
        title: "My Roles",
        infolist: ["To view only recent roles, click Recent Roles", "To access any other ConfChair features, please use the main menu"],
        btntext: "Recent Roles",
    }
]

// 我参与的论文列表
const conferenceMyList = ref([])
// 获取我参与的会议列表
function getConferenceMyList() {
    request.get(`/conference/joinlist`).then((res) => {
        // 如果为最近角色，只显示3条
        if (tabActive.value == 0) {
            conferenceMyList.value = res.data
            sortConferenceByCreateTime()
            conferenceMyList.value = res.data.slice(0, 3)
        }
        // 如果为全部角色，显示全部
        else {
            conferenceMyList.value = res.data
            sortConferenceByCreateTime()
        }
    })
}

// 排序
function sortConferenceByCreateTime() {
    conferenceMyList.value.sort((a, b) => {
        const timeA = new Date(a.createtime).getTime();
        const timeB = new Date(b.createtime).getTime();
        return timeB - timeA;
    });
}

// 切换角色展示
const tabrole = () => {
    // 如果为最近角色，切换全部角色
    if (tabActive.value == 0) {
        tabActive.value = 1
        getConferenceMyList()
    }
    // 如果为全部角色，切换最近角色
    else {
        tabActive.value = 0
        getConferenceMyList()
    }
}

// 以主席身份进入
const chairInner = (index, payload) => {
    router.push(`/common/managepapers?cid=${payload.cid}&acronym=${payload.acronym}`)
}

// 以审稿人身份进入
const subreviewerInner = (index, row) => {
    router.push(`/common/managereview?cid=${row.cid}&acronym=${row.acronym}&title=${row.title}&subnum=${row.subnum}`)
}

// 以投稿人身份进入
const authorInner = (index, row) => {
    router.push(`/common/listpapers?cid=${row.cid}&acronym=${row.acronym}`)
}

// 录用出版人身份进入
const proceedingsInner = (index, row) => {
    router.push(`/common/proceedingspapers?cid=${row.cid}&acronym=${row.acronym}`)
}

onMounted(() => {
    // 获取我参与过的会议
    getConferenceMyList();
})
</script>

<style lang="scss">
.role-container {
    .login-title {
        background: #b7dffd3b;
        margin-bottom: 50px;
        padding: 20px 0;

        .desc-box {
            font-size: 16px;
            padding: 0 30px;

            .title {
                font-weight: 700;
                font-size: 20px;
                padding: 0;
                -webkit-background-clip: text;
                background-clip: text;
                background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 79, 129));
                color: transparent;
            }

            .info {
                padding: 0;
                font-size: 14px;
                margin-bottom: 5px;
            }
        }
    }

    .click-tips {
        font-size: 13px;

        .text-line {
            border-bottom: 1px solid #88b5cb61;
            display: inline-block;
            margin-bottom: 20px;
            padding-bottom: 5px;
        }

        div {
            margin-bottom: 10px;
        }
    }

    .el-table .warning-row {
        background-color: #fdd9d921;
    }

    .el-table .success-row {
        background-color: #a2d2d714;
    }
}
</style>